import algoliasearch from 'algoliasearch/lite';
import { Input,Col } from "antd";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Configure, connectSearchBox, Highlight, InstantSearch } from 'react-instantsearch-dom';
import '../topHeader.css';
import Autocomplete from './AutoComplete';

// class SearchComponent extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {  }
//     }
//     render() { 
//         return (  <>
//         <AutoComplete
//         allowClear
//           dataSource={['dd','dss']}
//           style={{ width: 200 }}
//           loading
//           placeholder="input here"
//         />
//         <Search
//         loading
//             className="searchDashboard"
//             size="large"
//             placeholder="Search People & Skills..etc"
//             onSearch={value => }
//             enterButton
//           /></>  );
//     }
// }
 
const VirtalSearchBox = connectSearchBox(() => null);

const searchClient = algoliasearch(
  '9QIQS2J6GT',
  '79f1738807117e16dd3f9d6328335fd1'
);

class SearchComponent extends Component {
  state = {
    query: '',
  };

  onSuggestionSelected = (_, { suggestion }) => {
    this.setState({
      query: suggestion.name,
    });
  };

  onSuggestionCleared = () => {
    this.setState({
      query: '',
    });
  };

  render() {
    const { query } = this.state;

    return (
      <>
        <InstantSearch indexName="vedic_dev_students_list" searchClient={searchClient}>
          <Configure hitsPerPage={5} />
          <Col xs={20} sm={20} md={12} lg={12} xl={12}  >
          <Autocomplete 
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionCleared={this.onSuggestionCleared}
          />
          </Col>

        </InstantSearch>
        {/* <div></div>
        <Search
        loading
            className="searchDashboard"
            size="large"
            placeholder="Search People & Skills..etc"
            onSearch={value => }
            enterButton
          /> */}
      </>
    );
  }
}

function Hit(props) {
  return (
    <div>
      <Highlight attribute="name" hit={props.hit} />
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};
export default SearchComponent;